import { defineComponent, useAttrs, inject, computed, createBlock, openBlock, resolveDynamicComponent, unref, mergeProps, withCtx, createCommentVNode, createElementBlock, renderSlot, normalizeProps, createTextVNode, toDisplayString } from "vue";
import { loaderAnimationData } from "../../assets/lottie/loader.js";
import { _sfc_main as _sfc_main$1 } from "../WBadge/WBadge/index.js";
import "../WIcon/WIconStd/index.js";
import { WLottie } from "../WLottie/index.js";
import { useSmartLink } from "../WBreadcrumbs/WBreadcrumbs/index.js";
import { _export_sfc } from "../WAccordion/index.js";
import "../WIcon/WIconExt/index.js";
import "vue-router";
import './index.css';const BUTTON_SETS = [
  "accent",
  "alternate",
  "neutral",
  "error",
  "static-white",
  "static-black"
];
const BUTTON_SET_DEFAULT = BUTTON_SETS[0];
const BUTTON_SIZES = ["sm", "md", "lg"];
const BUTTON_SIZE_DEFAULT = BUTTON_SIZES[1];
const BUTTON_VARIANTS = [
  "primary",
  "secondary",
  "tertiary",
  "inline"
];
const BUTTON_VARIANT_DEFAULT = BUTTON_VARIANTS[0];
const DATA_TEST = {
  BUTTON: "w-button",
  TEXT: "w-button-text-wrapper",
  CONTENT_LEFT: "w-button-left-content",
  CONTENT_RIGHT: "w-button-right-content",
  WRAPPER: "w-button-wrapper",
  INCREMENT: "w-button-increment",
  LOADER: "w-button-loader"
};
const injectableProps = {
  button: Symbol("button")
};
const _hoisted_1 = ["data-t"];
const _hoisted_2 = ["data-t"];
const _hoisted_3 = ["data-t"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WButton",
  props: {
    text: { default: void 0 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 },
    attrType: { default: void 0 },
    compact: { type: Boolean },
    variant: { default: void 0 },
    size: { default: void 0 },
    set: { default: void 0 },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    to: { default: void 0 },
    block: { type: Boolean, default: void 0 }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const attrs = useAttrs();
    const props = __props;
    const emit = __emit;
    const { smartLink } = useSmartLink(() => ({
      to: props.to,
      disabled: props.disabled,
      onClick(e) {
        emit("click", e);
      }
    }));
    const injectedProps = inject(injectableProps.button, {});
    const attrType = computed(
      () => props.attrType ?? (injectedProps == null ? void 0 : injectedProps.attrType) ?? "button"
    );
    const variant = computed(
      () => props.variant ?? (injectedProps == null ? void 0 : injectedProps.variant) ?? BUTTON_VARIANT_DEFAULT
    );
    const block = computed(() => props.block ?? (injectedProps == null ? void 0 : injectedProps.block) ?? false);
    const set = computed(
      () => props.set ?? (injectedProps == null ? void 0 : injectedProps.set) ?? BUTTON_SET_DEFAULT
    );
    const size = computed(
      () => props.size ?? (injectedProps == null ? void 0 : injectedProps.size) ?? BUTTON_SIZE_DEFAULT
    );
    const compact = computed(() => props.compact ?? (injectedProps == null ? void 0 : injectedProps.compact) ?? false);
    const attrsComputed = computed(() => {
      const { attrs: attrsComputed2, tag } = smartLink.value;
      Object.assign(attrsComputed2, attrs);
      if (props.loading) {
        attrsComputed2["aria-disabled"] = "true";
      }
      if (props.loading && tag === "button") {
        attrsComputed2["disabled"] = true;
      }
      return attrsComputed2;
    });
    const classes = computed(() => [
      `--set-${set.value}`,
      `--size-${size.value}`,
      `--variant-${variant.value}`,
      {
        "--loading": props.loading,
        "--disabled": props.disabled,
        "--compact": compact.value,
        "--block": block.value
      }
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(smartLink).tag), mergeProps({
        type: attrType.value,
        class: ["w-button", classes.value],
        "data-t": unref(DATA_TEST).BUTTON
      }, attrsComputed.value), {
        default: withCtx(() => [
          _ctx.loading ? (openBlock(), createBlock(unref(WLottie), {
            key: 0,
            "animation-data": unref(loaderAnimationData),
            loop: "",
            "is-current-color": "",
            class: "w-button__loader",
            "data-t": unref(DATA_TEST).LOADER
          }, null, 8, ["animation-data", "data-t"])) : createCommentVNode("", true),
          !!_ctx.$slots.leftContent || _ctx.leftIcon ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "w-button__left-content",
            "data-t": unref(DATA_TEST).CONTENT_LEFT
          }, [
            renderSlot(_ctx.$slots, "leftContent", {}, () => [
              _ctx.leftIcon ? (openBlock(), createBlock(unref(_sfc_main$1), normalizeProps(mergeProps({ key: 0 }, _ctx.leftIcon)), null, 16)) : createCommentVNode("", true)
            ], true)
          ], 8, _hoisted_1)) : createCommentVNode("", true),
          !compact.value && (!!_ctx.$slots.default || !!_ctx.text) ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: "w-button__text-wrapper",
            "data-t": unref(DATA_TEST).TEXT
          }, [
            renderSlot(_ctx.$slots, "default", {}, () => [
              createTextVNode(toDisplayString(_ctx.text), 1)
            ], true)
          ], 8, _hoisted_2)) : createCommentVNode("", true),
          !compact.value && (!!_ctx.$slots.rightContent || _ctx.rightIcon) ? (openBlock(), createElementBlock("div", {
            key: 3,
            class: "w-button__right-content",
            "data-t": unref(DATA_TEST).CONTENT_RIGHT
          }, [
            renderSlot(_ctx.$slots, "rightContent", {}, () => [
              _ctx.rightIcon ? (openBlock(), createBlock(unref(_sfc_main$1), normalizeProps(mergeProps({ key: 0 }, _ctx.rightIcon)), null, 16)) : createCommentVNode("", true)
            ], true)
          ], 8, _hoisted_3)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["type", "class", "data-t"]);
    };
  }
});
const WButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-50169f02"]]);
export {
  WButton,
  injectableProps
};
